
  <!-- The routed views render here -->
  <router-outlet></router-outlet>
  <div *ngIf="isHeld==true" class="under-construction-overlay">
  <div class="maintenance-content">
    <mat-icon>construction</mat-icon>
    <span>Under planned maintenance</span>
    <p>{{ holdingDate | date:'mediumDate' }}</p>

      
    <div *ngIf="underMaintenance!=true" >
      <button mat-button color="primary" (click)="logout()">&lt;&lt; Logout</button>
      &nbsp;<button  mat-button color="primary" (click)="continue()">Continue &gt;&gt;</button>
    </div>  
    <div *ngIf="underMaintenance==true" >
      <button mat-button color="primary" (click)="logout()">Logout</button>
      </div>
  </div>
</div>

  <!-- Global Loader -->
  <app-loader></app-loader>